import createContextStore from '@src/contexts/contextStore';
import React from 'react';
import { SCOPE } from './types';
import reducer, { initialState } from './reducer';
import actions from './actions';

const { useStore, StoreProvider } = createContextStore({
  defaultValue: initialState,
  displayName: SCOPE,
});

function AutoInsightsProvider({ initValues = {}, children }) {
  return (
    <StoreProvider reducer={reducer} initialState={{ ...initialState, ...initValues }}>
      {children}
    </StoreProvider>
  );
}

export {
  useStore as useAutoInsightsStore,
  AutoInsightsProvider,
  actions,
};
